/*
 * Copyright (c) 2018-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { useOktaAuth } from '@okta/okta-react';
import React, { useState, useEffect } from 'react';
import {  Header } from 'semantic-ui-react';
import Button from '../../components/Button';
import LoginService from '../services/LoginService';
import store from 'store';
import Utils from '../utility/Utils';
import ajax from '../../services/Ajax';
import notification from '../../services/Notification';
import { color, rgb } from 'd3';
import SafteyAwarenessDialog from '../dialogs/SafteyAwarenessDialog';
import SafteyAwarenessController from '../controllers/SafetyAwarenessController';
import Dialog from '../../components/Dialog';
const Home = () => {
  const { authState, oktaAuth } = useOktaAuth();
  const [userInfo, setUserInfo] = useState(null);
  const [loginError, setLoginError] = useState(null); 
 const getCoCCertificate = (serialGUID) => {

    ajax.post('security/getSerialNumberForCoc', serialGUID).then((serial)=>{
        if (serial) {
            ajax.getExternal({ serialNumbers: serial }).then((response) => {
                if (response && response.File) {
                    const pdfData = response.File;
                    const blob = Utils.convertBase64toBlob(pdfData, 'application/pdf');
                    const fileName = 'Certificate' + '.pdf';
                    const fileURL = URL.createObjectURL(blob);

                    if (navigator.userAgent.match(/iPad/i) != null) {
                        window.open(fileURL);
                    }

                    else {
                        const tempLink = document.createElement('a');
                        tempLink.href = fileURL;
                        tempLink.download = fileName;
                        tempLink.click();
                        tempLink.remove();
                    }
                }
                else {
                    notification.action('error').post({ msg: 'Invalid Serial to download certificate', title: 'Error' });
                }
            })
            .catch(err => {
                notification.action('error').post({ msg: err.message, title: 'Error' });
            });               
        }
        else {
            notification.action('error').post({ msg: 'Invalid Serial to download certificate', title: 'Error' });
        }
    }) 
    .catch(err => {
        notification.action('error').post({ msg: err.message, title: 'Error' });
    });   
}
  const hashLoc = window.location.hash;
  const flag = hashLoc && Utils.contains(hashLoc, 'assetdetail') && hashLoc.split('/').length == 3 && Utils.isValidGuid(hashLoc.split('/')[2])
  const href=window.location.href
  console.log("href: "+href);
  const isProdEnv = href && (Utils.contains(href, 'dev') || Utils.contains(href, 'uat')) ? false : true;
  const loginEM=store.get('LoginErrorMessage');
 
  const cocLink = flag
    ? <span>Print <span className='select-link' onClick={handleCoCDownload} >CoC</span> from TechnipFMC manufacturing</span>
    : <span>Print <a className='select-link' href='https://coc.apps.technipfmc.com/' target='_blank'>CoC</a> from TechnipFMC manufacturing</span>;
  const dataBook = isProdEnv === true ? <span>Print electronic  <a className='select-link' href='https://databook.apps.technipfmc.com' target='_blank'>Data Books</a> and/or material test reports for individual or multiple assets from TechnipFMC Manufacturing.</span>
    : <span>Print electronic  <a className='select-link' href='https://databook.lab.technipfmc.com' target='_blank'>Data Books</a> and/or material test reports for individual or multiple assets from TechnipFMC Manufacturing.</span>;
    const HSEPreJobLink=<span>Access <a className='select-link' href='https://forms.office.com/Pages/ResponsePage.aspx?id=UckECKCTXUCA5PqHx1Udao5ka_saaXhLlUV9l46XPhhUREE2TkRKM0xUMDBWWTBQVzRHM00zVUlMRC4u' target='_blank'>TechnipFMC HSE Pre Job New JSA Form</a></span>;
    const SBSSLink=<span>Access <a className='select-link' href='https://digicorner.sharepoint.com/sites/TheWell/SitePages/Ser.aspx?from%3D=LightGBM' target='_blank'>Surface Business Systems SharePoint</a> in The Well (employees only).</span>;
    const handleCoCDownload = () => {
    const hashLoc = window.location.hash;
    const serialGUID = hashLoc.split('/')[2];
    getCoCCertificate(serialGUID);
  }
  const divStyle = {
    height: "100vh",
    "backgroundColor":"rgba(0, 0, 0, 0.6)",
     color: 'white',
     padding: '1rem'
  };
  const welcomeDiv={
    height: "100vh",
     color: 'white',
     paddingTop: '5rem'
  };
  const technipfmcLogo = {
    height: '12mm',
    width: '57mm',
    marginBottom: '1px',
    position: 'fixed',
    top: '1rem',
    left: '3rem',
    right: '1rem',
}
  const mainDiv={
    "margin": "auto",
    "fontfamily": "-apple-system, BlinkMacSystemFont, sans-serif",
    "overflow": "auto",
    "background": "linear-gradient(315deg, rgba(101,0,94,1) 3%, rgba(60,132,206,1) 38%, rgba(48,238,226,1) 68%, rgba(255,25,25,1) 98%)",
    //"animation": "gradient 15s ease infinite",
    "backgroundSize": "100% 100%",
    "backgroundAttachment": "fixed",
    "width":"100vw",
    "height":"133vh",
    "backgroundImage":"url('./assets/images/Suriname Commercial Port.png')"

}
const pFont={
  fontSize:'2rem',
  color:rgb(20, 20, 20)
}
const pFont2={
  fontSize:'1rem',
  color:rgb(20, 20, 20)
}
const pFontError={
  fontSize:'2rem',
  color:rgb(20, 20, 20),
  padding:'2rem',
  position:'fixed'
}

  useEffect(() => {
    oktaAuth.handleLoginRedirect();
    if (!authState || !authState.isAuthenticated) {
      // When user isn't authenticated, forget any user info
      setUserInfo(null);
    } else {
      oktaAuth.getUser().then((info) => {
        setUserInfo(info);
        setLoginError(null);
        store.set('oktaaccesstoken', oktaAuth.getAccessToken());
        //LoginService.login(info.email,'', '');
        const loginInfo = LoginService.loginInfo;
        if(!loginInfo)
        {
          LoginService.login(info.email,'', '');
        }
        else
        {
          LoginService.autoLogin();
        }
      }).catch((err) => {
        setLoginError(err);
        console.error(err);
      });
    }
  }, [authState, oktaAuth]); // Update if authState changes
    
  const login = async () => {
    oktaAuth.signInWithRedirect({ originalUri: '/' });
  };
   if (!authState) {
    return (
      <div>Loading...</div>
    );
  }
  const loginReset = () => {
   LoginService.logout();
  }
  
  return (
    <div id="home"  className='row flex-row-reverse' style={mainDiv} > 
        <img style={technipfmcLogo} src='./assets/images/logo.png' />
        { authState.isAuthenticated && !userInfo && <div style={divStyle}>Loading user information...</div>}
      <div className='col-md-4 justify-content-center'>
        {!authState.isAuthenticated && ( 
          <div style={divStyle} >   
        <Header as="h1">Welcome to Inteserv </Header>      
          <p>
           By clicking on the login button below, You will be logged in to Inteserv using Okta Sign-In widget hosted within the application.
          </p>
          <Button icon='fas fa-sign-in-alt' variant='info' size='lg'  onClick={login} type='submit' className='btn btn-success btn-block'>Login</Button>
              <div className='inteserv-links'> {cocLink} </div>
              <div className='inteserv-links'>{dataBook}</div>
              {/* <div className='inteserv-links'>{HSEPreJobLink}</div> */}
              <div className='inteserv-links'>{SBSSLink}</div>
        </div>
        )}
      </div>
      {authState.isAuthenticated && userInfo && !loginEM
        && (
        <div className='col-md-8 justify-content-center' style={welcomeDiv}>
          <p id="welcome" style={pFont}>
            Welcome, &nbsp;
            {userInfo.name}
            !
          </p>
          <p style={pFont2}>
            You have successfully logged into Inteserv. 
          </p>
          {/* {LoginService.loginInfo && !LoginService.loginInfo.isCustomer && (Dialog.showDialog(<SafteyAwarenessDialog header={'Important Reminder!'} controller={new SafteyAwarenessController()}/>))} */}
        </div>
        )}
        {authState.isAuthenticated && loginEM&&(
          <div className='col-md-8 justify-content-center' style={welcomeDiv}>
          <p id="error" style={pFontError}>
           {loginEM}  <button onClick={loginReset}>Login</button>
          </p>
          </div>
        )}
    </div>
  );
};
export default Home;
